/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFeedbackListResponseFeedback } from "../../funcs/llmFeedbackListResponseFeedback.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListResponseFeedbackRequest$inboundSchema,
};

export const tool$llmFeedbackListResponseFeedback: ToolDefinition<typeof args> =
  {
    name: "llm-feedback-list-response-feedback",
    description: `List response feedback

Retrieves a paginated list of feedback entries recorded on the caller's agent responses, ordered by the response's creation date. Supports filtering by rating. An \`after\` cursor that no longer resolves to a response visible to the caller — including responses that have since been deleted — returns 400; restart pagination from the first page.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await llmFeedbackListResponseFeedback(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
